module.exports = __webpack_public_path__ + "img/P4-0-5.4b6d4c73.svg";